import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import HotelOffersSkeleton from '../components/HotelOffersSkeleton/HotelOffersSkeleton';
import * as constants from '../util/constants';

class AppSingleCptThingsToDoRelatedOffers extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      allOffers: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.postID = '';
    const hotelOffersWrapper = $('#hotel-offers-wrapper');
    if (hotelOffersWrapper.length) {
      this.postID = hotelOffersWrapper.data('post-id');
    }

    // Bind "this"
    this.loadHotelOffers = this.loadHotelOffers.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  loadHotelOffers() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_HOTEL_THINGS_TO_DO_OFFERS,
      'postID': this.postID,
      'offset': 0,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const offersCount = response.data['offers_count'];
          const offers = [...response.data['offers']];

          if (offersCount > 0) {
            this.setState({
              loading: false,
              allOffers: [...offers],
              loadMoreLoading: false,
              loadedAll: offersCount == offers.length,
            });
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  componentDidMount() {
    // Load hotel offers on first page load
    this.loadHotelOffers();
  }

  componentDidUpdate() {
    // Equal height for elements
    $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
  }

  render() {
    const {
      loading,
      allOffers,
      loadMoreLoading,
    } = this.state;

    return (
      <React.Fragment>
        {
          !loading && allOffers.length > 0 && (
            <div className="row rooms-slider">
              {
                allOffers.map((offer, i) => {
                  return (
                    <div className="col-12 col-lg-6 mb-4 px-2 px-lg-3" key={i}>
                      <a href={offer['link']} className="single-room-wrapper d-block">
                        <div className="preview-images">
                          <div className="featured-image bg-center position-relative" style={{backgroundImage: `url(${offer['image']})`}} />
                        </div>
                        <div className="room-info balance-elements">
                          {
                            offer['types'].length > 0 && (
                              <React.Fragment>
                                {
                                  offer['types'].map((type, i) => {
                                    return (
                                      <span className="badge badge-dark mr-2 mb-3 bg-red p-2 text-uppercase" key={i}>
                                        {type}
                                      </span>
                                    );
                                  })
                                }
                              </React.Fragment>
                            )
                          }
                          {
                            offer['name'].length > 0 && (
                              <h2 className="name mb-0">{offer['name']}</h2>
                            )
                          }
                          {
                            offer['description'] && (
                              <div className="description">
                                <p dangerouslySetInnerHTML={{__html: offer['description']}} />
                              </div>
                            )
                          }
                          {
                            offer['price_label'] && (
                              <div className="price">
                                {offer['price_label']}
                              </div>
                            )
                          }
                        </div>
                      </a>
                    </div>
                  );
                })
              }
            </div>
          )
        }
        {
          (loading || loadMoreLoading) && (
            <HotelOffersSkeleton />
          )
        }
      </React.Fragment>
    );
  }
}

export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Hotel Booking Form onSubmit
    // $ ('.hotel-booking-form').submit(function(e) {
    //   if ($(this).find('input.check-in').val().toLowerCase() === '' ||
    //     $(this).find('input.check-out').val().toLowerCase() === '') {
    //     $(this).find('.date-validator').show();
    //     e.preventDefault();
    //   } else {
    //     $(this).find('.date-validator').hide();
    //   }
    // });

    // Hotel offers
    const hotelOffersWrapper = $('#hotel-offers-wrapper');
    if (hotelOffersWrapper.length) {
      ReactDOM.render(<AppSingleCptThingsToDoRelatedOffers />, hotelOffersWrapper[0]);
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptThingsToDo.js